// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"j2-z","sponsoredTooltipWrapper":"k2-z","sponsoredTooltip":"l2-z","newCard":"m2-z"};